import { useState } from "react"

import { format, startOfDay } from "date-fns"

import Icon from "@/components/Icon"
import { Calendar } from "@/components/ui/calendar"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { cn } from "@/lib/utils"

interface DatePickerProps {
  date: Date | undefined
  onDateChange: (date: Date | undefined) => void
}

const DatePicker = ({ date, onDateChange }: DatePickerProps) => {
  const [open, setOpen] = useState(false)

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={cn(
            "flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
            !date && "text-muted-foreground",
          )}
        >
          <span className="truncate">{date ? format(date, "dd/MM/yy") : "Select date"}</span>
          <Icon name="caretDown" className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={date}
          onSelect={(selectedDate) => {
            onDateChange(selectedDate)
            setOpen(false)
          }}
          weekStartsOn={1}
          disabled={{ before: startOfDay(new Date()) }}
          showOutsideDays={false}
          numberOfMonths={1}
        />
      </PopoverContent>
    </Popover>
  )
}

export default DatePicker
